/**
 * jQuery Plugins for Third-party Apps (Judge.me, etc.)
 * Fixes: SYRS-SHOPIFY-1C, 18, 1F, 1G (.urlParam, .unveil missing)
 *
 * @CODE:FIX-SENTRY-JP-KR
 */

(function($) {
  'use strict';

  /**
   * URL Parameter Parser Plugin
   * Usage: $.urlParam('paramName')
   * Returns: parameter value or null
   */
  $.urlParam = function(name) {
    if (!name) return null;

    const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
    return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : null;
  };

  /**
   * jQuery fn.urlParam (for chaining)
   * Usage: $('body').urlParam('paramName')
   */
  $.fn.urlParam = function(name) {
    return $.urlParam(name);
  };

  /**
   * Unveil Lazy Loading Plugin (Simplified)
   * Usage: $('img').unveil(threshold, callback)
   *
   * Note: Modern browsers use native lazy loading (loading="lazy")
   * This is a fallback for older browsers or third-party apps
   */
  $.fn.unveil = function(threshold, callback) {
    var $elements = this;
    var loaded;
    threshold = threshold || 0;

    function unveil() {
      var inview = $elements.filter(function() {
        var $e = $(this);
        if ($e.is(':hidden')) return false;

        var wt = $(window).scrollTop();
        var wb = wt + $(window).height();
        var et = $e.offset().top;
        var eb = et + $e.height();

        return eb >= wt - threshold && et <= wb + threshold;
      });

      loaded = inview.trigger('unveil');
      $elements = $elements.not(loaded);
    }

    $(window).on('scroll.unveil resize.unveil lookup.unveil', unveil);
    unveil();

    // Handle unveil event
    this.on('unveil', function() {
      var source = this.getAttribute('data-src');
      if (source) {
        this.setAttribute('src', source);
        if (typeof callback === 'function') callback.call(this);
      }
    });

    return this;
  };

})(jQuery);
